export const normalizeCharacter = (value: string): string | null => {
    const normalized = value.normalize('NFC')
    return [...normalized].length === 1 && !/\s/u.test(normalized) ? normalized : null
}
